import { BarChart3, Users, MousePointerClick } from 'lucide-react';

interface RevealHighlightProps {
  /** compact = 120px mobile cards. full = larger desktop/list cards. */
  variant?: 'compact' | 'full';
}

/**
 * "Tap to compare picks" attention affordance.
 * Violet glow + chart/users circular badge + pulsing tap pointer.
 * Fully rendered INSIDE card bounds — safe with overflow-hidden.
 */
export function RevealHighlight({ variant = 'full' }: RevealHighlightProps) {
  const isCompact = variant === 'compact';

  const badgeDim = isCompact ? 'w-6 h-6' : 'w-9 h-9';
  const badgeOffset = isCompact ? 'top-1.5' : 'top-2.5';
  const chartSize = isCompact ? 'w-3 h-3' : 'w-4 h-4';
  const tap = isCompact
    ? 'w-4 h-4 top-1 left-1'
    : 'w-5 h-5 top-2 left-2';

  return (
    <>
      <div
        aria-hidden
        className={`pointer-events-none absolute ${badgeOffset} left-1/2 -translate-x-1/2 ${badgeDim} rounded-full bg-background ring-2 ring-violet-400 flex items-center justify-center z-20`}
      >
        <BarChart3 className={`${chartSize} text-violet-300`} strokeWidth={2.4} />
        {!isCompact && (
          <div className="absolute -bottom-1 -right-1 bg-background rounded-full p-[2px] ring-1 ring-violet-400/80">
            <Users className="w-2 h-2 text-violet-300" strokeWidth={2.4} />
          </div>
        )}
      </div>
      <MousePointerClick
        aria-hidden
        className={`pointer-events-none absolute ${tap} text-violet-300 drop-shadow-[0_0_5px_rgba(167,139,250,0.9)] animate-pulse z-20`}
        strokeWidth={2.4}
      />
    </>
  );
}

export default RevealHighlight;
